import { useCallback, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import { INTERNAL_DEAL_STATUS, setDealStatus } from 'cache/deal-status'
import LOCK_DEAL_MUTATION from 'queries/mutations/deal-lock'
import { LockUnlockDealResponse } from 'queries/mutations/deal-unlock'
import { MessageType } from 'ts/enums/messageType.enums'
import { useUserProfile } from './use-user-profile'

export const useUnlockDeal = () => {
  const { userId } = useUserProfile()
  const [lockDealMutation, { data, loading, error }] = useMutation<LockUnlockDealResponse>(
    LOCK_DEAL_MUTATION,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const handleUnlockDeal = useCallback(
    async (dealId: number, userIdInput?: string) => {
      try {
        await lockDealMutation({
          variables: {
            bdId: dealId,
            userId: userIdInput || userId,
            lockFlag: false,
            bdIds: [dealId],
          },
        })
      } catch (error) {
        setAlertQueue({
          type: MessageType.ERROR,
          message: 'Failed to unlock deal. Please try again.',
        })
        return { error }
      }
    },
    [lockDealMutation, userId]
  )

  useEffect(() => {
    if (data?.lockUnlockDeal.isSuccess) {
      setDealStatus(INTERNAL_DEAL_STATUS.CLOSED_UNLOCKED)
    }
  }, [data?.lockUnlockDeal.isSuccess])

  return {
    unlockDealMutation: handleUnlockDeal,
    isSuccessfull: data?.lockUnlockDeal.isSuccess,
    isLoading: loading,
    error,
  }
}
